<!--简历编辑-求职意向-->
<template>
	<div class="job-intentsion" :style="{'border-bottom':status==1?'1px solid #eee':'none','padding-bottom':status==1?'25px':'0'}">

		<h3 class="c-title">求职意向
			<a href="javascript:;" class="btn-edit" :class="{'disabled':!editable}" v-if="status==1" @click="editShow">
				<i class="icon">
					<img src="../../assets/img/common/icon-pencil.png" v-if="editable" />
					<img src="../../assets/img/common/icon-pencil-off.png" v-if="!editable"/>
				</i>
				<span>&nbsp;编辑</span>
			</a>
		</h3>

		<!--初始状态-->
		<div class="no-data" v-if="status==0">
			<resume-undone-template blockText="求职意向" :showTitle="false" :editable="editable" v-on:editBtnClick="status=2" />
		</div>

		<!--展示状态-->
		<div class="job-intentsion-complete" v-if="status==1">
			<div>
				<div class="c-line"><label>期望行业：</label>{{industryText}}</div>
				<div class="c-line"><label>期望职业：</label>{{occupationText}}</div>
				<div class="c-line"><label>期望地点：</label>{{locationText}}</div>
				<div class="c-line">
					<label>期望年薪：</label>
					<span v-if="negotiable">面议</span>
					<span v-if="!negotiable">{{salary.from}}-{{salary.to}}万</span>
				</div>
			</div>
		</div>

		<!--编辑状态-->
		<div class="editting" v-if="status==2">

			<div class="row-24">
				<div class="row-12">
					<label class="label">期望行业</label>
					<industry-picker :maxcount='3' @finish-industry-pick='setIndustry' :text="industryText" v-model="industry"></industry-picker>
					<p class="error-tips" v-if="industryError">请至少选择一个行业</p>
				</div>

				<div class="row-12">
					<label class="label">期望职业</label>
					<occupation-picker :maxcount='3' @finish-occupation-pick='setOccupation' :text="occupationText" v-model="occupation"></occupation-picker>
					<p class="error-tips" v-show="occupationError">请至少选择一个期望职业</p>
				</div>
			</div>

			<div class="row-24">
				<div class="row-12">
					<label class="label">期望地点</label>
					<input type="text" class="base-input-lg" placeholder="请选择" readonly="readonly" :class="{'error':location.error}" @click="openLocationModal" v-model="locationText">
					<p class="error-tips" v-if="locationError">请至少选择一个期望地点</p>
				</div>

				<div class="row-12">
					<label class="label">期望年薪</label>
					<div class="time-range-block cf">
						<input type="number" min="0" class="base-input-mini wider fl" :class="{'disabled':negotiable}" :disabled="negotiable" v-model="salary.from" />
						<span class="unit-span">万</span>
						<div class="split-line cf"></div>
						<input type="number" min="0" class="base-input-mini wider fl" :class="{'disabled':negotiable}" :disabled="negotiable" v-model="salary.to" />
						<span class="unit-span">万</span>
						<div class="not-yet">
							<input type="checkbox" name="keepsecret" v-model='negotiable' />
							<div class="fake-checker" @click="negotiable=!negotiable">
								<img src="../../assets/img/common/icon-circle-hollow.png" v-if="!negotiable" />
								<img src="../../assets/img/common/icon-circle-tick.png" v-if="negotiable" />
							</div>
							<span>保密</span>
						</div>
					</div>
					<p class="error-tips" v-if="showSalaryError">{{salaryErrorText}}</p>
				</div>
			</div>

			<div class="row-24-block">
				<a href="javascript:;" class="btn-operation btn-save" @click="resumeJobIntensionEditSave">保存</a>
				<a href="javascript:;" class="btn-operation btn-cancel" @click="resumeJobIntensionEditCancel">取消</a>
			</div>

		</div>

		<!-- 选择地区 -->
		<modal :isModal="showLocationModal" :isBtn="false" :width="580" :height="490" @btnCancel="btnCancelLocation">
			<span slot="title">选择地址</span>
			<div slot="content">
				<location :propsLocation="propsLocationList" :maxCount="3" @btnCancel="btnCancelLocation" @btnSubmit="btnSubmitLocation"></location>
			</div>
		</modal>

	</div>
</template>

<script>
	import Modal from "@/components/Modal/Modal";
	import Location from "@/components/Location/Location";
	import ResumeUndoneTemplate from '@/components/EditResume/ResumeUndoneTemplate.vue'
	import IndustryPicker from '@/components/Common/IndustryPicker.vue'
	import OccupationPicker from '@/components/Common/OccupationPicker.vue'

	import { httpResumeJobIntensionGet, httpResumeJobIntensionEditSave } from '@/api/resume';

	export default {
		name: 'ResumeJobIntension',
		props: {
			orderId: {
				required: true
			},
			resumeId: {
				required: true
			},
			editable: {
				type: Boolean,
				required: true
			}
		},
		components: {
			ResumeUndoneTemplate,
			IndustryPicker,
			OccupationPicker,
			Modal,
			Location,
		},
		data() {
			return {
				status: 0, //0-没资料，1-编辑完成，2-编辑中
				resumeid: this.resumeId,

				//行业
				industry: [],
				industryText: '',
				industryError: false,

				//职业
				occupation: [],
				occupationText: '',
				occupationError: false,

				//地区
				showLocation: [], // 展示拼接的数组
				locationChild: [], // 地区传来的对象
				location: [],
				propsLocationList: [], // 地区定义集合
				showLocationModal: false, // 地区弹窗
				locationText: '',
				locationError: false,

				//薪资
				salary: {
					from: '',
					to: '',
				},
				//是否面议
				negotiable: false,
				showSalaryError: false,
				salaryErrorText: '',
			}
		},
		mounted() {
			setTimeout(() => this.getResumeJobIntension(), 30);
		},
		methods: {
			//打开编辑
			editShow() {
				if(!this.editable) return;
				this.$emit('set-edit-status', 1);
				this.status = 2;
			},
			//保存编辑
			resumeJobIntensionEditSave() {
				const oData = this.buildData(); //请求的数据
				const canISubmit = this.beforeSave();
				if(!canISubmit) return;

				httpResumeJobIntensionEditSave(oData).then(r => {
					if(r.success) {
						this.$message({
							type: 'success',
							message: '保存成功',
							duration: 800,
							onClose: () => {
								this.getResumeJobIntension();
								this.status = 1;
								this.$emit('set-edit-status', 2);
							}
						});
					} else {
						this.$message.error('保存求职意向失败');
					}
				}).catch(err => {
					this.$message.error('保存求职意向失败');
				});
			},

			//取消保存编辑-再获取一次数据
			resumeJobIntensionEditCancel() {
				this.getResumeJobIntension();
				this.$emit('set-edit-status', 2);
			},

			buildData() {
				let oData = {};
				let industryArray = [];
				this.industry.forEach(item => {
					industryArray.push(item.id);
				});
				let occupationArray = [];
				this.occupation.forEach(item => {
					occupationArray.push(item.id);
				});

				let locationArray = [];
				this.showLocation.forEach(item => {
					locationArray.push(item.locationId);
				});

				oData.resumeId = this.resumeId;
				oData.desiredIndustry = industryArray;
				oData.desiredOccupation = occupationArray;
				oData.desiredLocation = locationArray;
				oData.salaryIsNegotiable = this.negotiable;
				oData.desiredSalaryTo = this.salary.to || 0;
				oData.desiredSalaryFrom = this.salary.from || 0;

				return oData;
			},

			//检查各选项是否必填
			beforeSave() {
				if(this.industry.length == 0) {
					this.industryError = true;
					return false;
				} else {
					this.industryError = false;
				}

				if(this.occupation.length == 0) {
					this.occupationError = true;
					return false;
				} else {
					this.occupationError = false;
				}

				if(this.location.length == 0) {
					this.locationError = true;
					return false;
				} else {
					this.locationError = false;
				}

				//如果选择面议
				if(!this.negotiable) {
					//期望年薪是否合理
					if(!this.salary.from || !this.salary.to) {
						this.showSalaryError = true;
						this.salaryErrorText = "请输入完整的期望年薪";
						return false;
					} else {
						this.showSalaryError = false;
					}

					if(Number(this.salary.from) < 0 || Number(this.salary.to) < 0) {
						this.showSalaryError = true;
						this.salaryErrorText = "期望年薪必须大于等于0";
						return false;
					} else {
						this.showSalaryError = false;
					}

					if(Number(this.salary.from) > Number(this.salary.to)) {
						this.showSalaryError = true;
						this.salaryErrorText = "期望年薪起始值不能大于终止值";
						return false;
					} else {
						this.showSalaryError = false;
					}
				}

				return true;
			},

			//地点选择选择
			openLocationModal() {
				this.showLocationModal = true;
				if(this.showLocation.length > 0) {
					this.propsLocationList = JSON.parse(JSON.stringify(this.showLocation));
				} else {
					this.propsLocationList = [];
				}
			},

			btnCancelLocation() {
				this.showLocationModal = false;
			},

			btnSubmitLocation(item) {
				this.locationChild = item;
				this.showLocation = JSON.parse(JSON.stringify(this.locationChild));
				this.buildLocationText();
				this.showLocationModal = false
			},

			//拼接出期望地点文本
			buildLocationText() {
				var temp_str = "";
				this.showLocation.forEach(item => {
					this.location.push(item.locationId);
					temp_str += (item.location + ",");
				});
				this.locationText = temp_str.substr(0, temp_str.length - 1);
			},

			//完成行业选择
			setIndustry(result) {
				this.industry = result;
				this.buildIndustryText();
			},

			//拼接出期望行业文本
			buildIndustryText() {
				let temp_str = '';
				this.industry.forEach(item => {
					temp_str += item.name + '，';
				});
				let len = temp_str.length - 1;
				this.industryText = temp_str.substr(0, Number(len));
			},

			setOccupation(result) {
				this.occupation = result;
				this.buildOccupationText();
			},

			//拼接出期望职业文本
			buildOccupationText() {
				let temp_str = '';
				this.occupation.forEach(item => {
					temp_str += item.name + '，';
				});
				let len = temp_str.length - 1;
				this.occupationText = temp_str.substr(0, Number(len));
			},

			resetData() {
				this.industry = [];
				this.industryText = '';
				this.industryError = false;
				this.occupation = [],
					this.occupationText = '',
					this.occupationError = false,
					this.showLocation = [], // 展示拼接的数组
					this.locationChild = [], // 地区传来的对象
					this.location = [],
					this.propsLocationList = [], // 地区定义集合
					this.salary = {
						from: '',
						to: '',
					},
					this.negotiable = false;
				this.showSalaryError = false;
			},

			//获取简历的求职意向
			getResumeJobIntension() {
				if(!this.resumeId) {
					this.status = 0;
					this.resetData();
					return;
				}
				const prama = this.resumeId;
				httpResumeJobIntensionGet(prama).then(r => {
					//console.log(r);
					if(r.success) {
						const m = r.data;
						//判定为初次填写状态
						if(m.desiredIndustry.length == 0 && m.desiredLocation == 0) {
							this.status = 0;
						} else {
							this.industry = m.desiredIndustry;
							this.buildIndustryText();

							//给地点附上能显示的值
							this.showLocation.length = 0;
							m.desiredLocation.forEach(item => {
								const tempObj = {
									locationId: item.locationId,
									location: item.name,
								}
								this.showLocation.push(tempObj);
								this.buildLocationText();
							})
							this.occupation = m.desiredOccupation;
							this.buildOccupationText();
							this.negotiable = m.salaryIsNegotiable;
							this.salary.from = m.desiredSalaryFrom;
							this.salary.to = m.desiredSalaryTo;
							this.status = 1;
						}

					} else {
						this.$notify({
							title: '提示',
							message: '获取简历求职意向失败',
							type: 'warning'
						});
					}
				}).catch(error => {
					console.log(error);
					this.$notify({
						title: '提示',
						message: '获取简历求职意向失败',
						type: 'warning'
					});
				});
			}
		}, //methods结束
		watch: {
			'negotiable': function(val, oldVal) {
				//选择面议
				if(val) {
					this.salary.from = '';
					this.salary.to = '';
				}
			}
		}
	}
</script>

<style scoped lang='less'>
	@import url("../../assets/css/editResume.less");
	.job-intentsion {
		margin-bottom: 30px;
		padding-bottom: 25px;
		border-bottom: 1px solid #eee;
	}
	
	.job-intentsion-complete {
		.c-line {
			line-height: 38px;
			font-size: 14px;
			label {
				color: #666;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/EditResume/ResumeJobIntension.vue